{{$store.getters.isLogin}}
<template>
  <v-app id="inspire">
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Login form</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    label="Login"
                    name="login"
                    type="text"
                    @input="changeUser"
                    require
                  ></v-text-field>

                  <v-text-field
                    id="password"
                    label="Password"
                    name="password"
                    type="password"
                    @input="changePassword"
                    require
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                  <v-btn color="primary" @click="checkUser">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import {store} from '../store/store'
  export default {
    
    store,
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
    }),
    methods:{
      changeUser:function(event){
        this.$store.commit('setUsername',event);
        //console.log(event);
      },
      changePassword:function(event){
        this.$store.commit('setPassword',event);
        //console.log(event);
      },
      checkUser:function(){
        if(this.$store.getters.usernameTxt === "gpsts" && this.$store.getters.passwordTxt==="weerapat"){
          this.$store.commit('setLogin',true);
          this.$router.replace({name : "Home"});
          
        }
        else{
          this.$store.commit('setLogin',false);
        }
      },
    }    
  }
</script>